GW.define('AdminSummary.Screen', 'Main.Screen', {
	title: _('Administrační přehled'),
	titleIcon: 'bug',
	views: [],

	'after:initComponent'() {
		this.el.classList.add('summary-screen');
	},

	getSidebarMenu() {
		return this.views.map((v, idx) => {
			return {
				nodeName: 'a',
				className: 'item',
				href: APP_BASE + 'summary/' + idx,
				textContent: v.name,
			};
		});
	},
});

// {{{ AdminSummary.StateScreen

GW.define('AdminSummary.View', 'AdminSummary.Screen', {
	'after:initComponent'() {
		let me = this;

		this.data = {
			columns: [],
			rows: [],
		};

		this.bodyEl.gwCreateChild({
			ref: 'titleEl',
			nodeName: 'h2',
		}, this);

		this.bodyEl.gwCreateChild({
			ref: 'table',
			xtype: 'SmartTable',
			emptyText: _('Nic'),
			'after:initComponent'() {
				this.el.style['white-space'] = 'nowrap';
			},
			renderRow(tr, row) {
				tr.title = row[me.data.columns[0].name];
			},
			getColumns() {
				let colors = ['urgent', 'warn', 'notice'];

				return me.data.columns.map(c => {
					let limits = [...(c.limits || [])].reverse();

					return {
						id: c.name,
						name: c.label || c.name,
						hint: c.hint,
						align: c.align || 'right',
						formatCell(td, v, row) {
							if (Array.isArray(v)) {
								td.textContent = v.join(' / ');

								out: for (let [idx, l] of limits.entries()) {
									for (let vv of v) {
										if (vv > l) {
											td.style.background = colors[idx];
											break out;
										}
									}
								}
							} else {
								td.textContent = v;

								for (let [idx, l] of limits.entries()) {
									if (v > l) {
										td.dataset.highlight = colors[idx];
										break;
									}
								}
							}
						},
					};
				});
			},
		}, this);
	},

	async applyParams(params) {
		let view = params.get('id');

		let signal = Utils.abortAndRetry(this, 'reload');
		this.data = await REST.GET('admin-summary/view/' + encodeURIComponent(view), null, {signal});

		this.titleEl.textContent = this.data.name;
		this.table.setData(this.data.rows);
	},
});

// }}}

// {{{ Routes

Application.addRoutes([{
	group: 'auth',
	module: 'summary',
	path: APP_BASE + 'summary',
	async handler({params, captures}) {
		await Application.replaceRoute(APP_BASE + 'summary/0');
	}    
}, {
	group: 'auth',
	module: 'summary',
	path: APP_BASE + 'summary/{view}',
	async handler({params, captures}) {
                let views = await REST.GET('admin-summary/views');

		params.set('id', captures.view);

		let c = Application.show({
			id: 'summary.view.' + captures.view,
			xtype: 'AdminSummary.View',
			views,
		});

		await c.applyParams(params);
	}    
}]);

Application.registerModule({
	id: 'summary',
	title: _('Administrační přehled'),
	tagline: _('Souhrny nastavení a změn'),
	icon: 'bug',
	href: APP_BASE + 'summary',
});

// }}}
